import { useWidgetData } from "../Contexts/dashboardHooks";
import { resolveDateRange } from "../Utils/resolveDateRange";
import type { Table2DComponentSpec, Table2DBuilderMisc } from "../Processing/types";

const DIM_LABELS: Record<string, string> = {
  player: "Player", position: "Position", drill: "Drill",
  metric: "Metric", day: "Day", week: "Week", month: "Month", weekday: "Weekday",
};

export function Table2DInfo({ id }: { id: string }) {
  const data = useWidgetData(id);
  if (!data || data.type !== "table_2d") return null;
  const spec = data.spec as Table2DComponentSpec;

  const misc = spec.table_2d_builder_misc as Table2DBuilderMisc;

  const dateLabel = resolveDateRange(misc);

  const names = misc?.selectedSubjectNames ?? [];
  const MAX = 20;
  const subjectLabel = names.length === 0
    ? "Full Team"
    : names.length <= MAX
      ? names.join(", ")
      : `${names.slice(0, MAX).join(", ")} (+${names.length - MAX} more)`;

  const rowLabel = DIM_LABELS[spec.rowDimension] ?? spec.rowDimension;
  const colLabel = DIM_LABELS[spec.colDimension] ?? spec.colDimension;

  return (
    <div style={{ maxWidth: 320, fontSize: 12, lineHeight: 1.6 }}>
      <div style={{ paddingLeft: 4, color: "rgba(0,0,0,0.65)" }}>
        <div>Rows: {rowLabel}</div>
        <div>Columns: {colLabel}</div>
        <div>Dates: {dateLabel}</div>
        <div>Players: {subjectLabel}</div>
      </div>
    </div>
  );
}
